import { use, useCallback, useSyncExternalStore } from "react";
import { FieldDestinationContext } from "./FieldDestinationContext.ts";
import type { FieldDestinationSnapshot, FieldDestinationStore } from "./fieldDestinationStore.ts";

const subscribeToNothing = (): (() => void) => () => {};
const emptySnapshot: FieldDestinationSnapshot = { destinations: [] };
const getEmptySnapshot = () => emptySnapshot;

export const useIsAddingFields = (): boolean => {
  const store = use(FieldDestinationContext);
  const getIsAdding = useCallback(() => store?.getSnapshot().destination !== undefined, [store]);
  return useSyncExternalStore(store?.subscribe ?? subscribeToNothing, getIsAdding);
};

export const useFieldDestination = (): FieldDestinationSnapshot & {
  store: FieldDestinationStore | undefined;
  stopAddingFields: () => void;
} => {
  const store = use(FieldDestinationContext);
  const snapshot = useSyncExternalStore(store?.subscribe ?? subscribeToNothing, store?.getSnapshot ?? getEmptySnapshot);
  const stopAddingFields = useCallback(() => store?.select(undefined), [store]);
  return { ...snapshot, store, stopAddingFields };
};
